import { PromoProviderTypes } from '@piceasoft/core';

export const getPromoProviderIcon = (type: PromoProviderTypes):string => {
    switch(type) {
        case PromoProviderTypes.Promotion: return "Shop";
        case PromoProviderTypes.Provider: return "Money";
    }
}